// extracted by mini-css-extract-plugin
export default {"-large":"image-item-popup-module__-large--BpcWj","popup":"image-item-popup-module__popup--cOWGT","popUpContainer":"image-item-popup-module__popUpContainer--SrkAD"};